import { jsx as i, jsxs as F } from "react/jsx-runtime";
import I from "classnames";
import { useState as L, useRef as E, useLayoutEffect as N } from "react";
import e from "./index.es794.js";
import { CardProvider as j, useCard as B } from "./index.es795.js";
import { CardHeader as T } from "./index.es796.js";
import { CardContent as q } from "./index.es797.js";
import { CardFooter as K } from "./index.es798.js";
import { Box as O } from "./index.es519.js";
import { onKeyDownEnterAndSpace as P } from "./index.es526.js";
const R = "card-component", l = (t) => /* @__PURE__ */ i(j, { children: /* @__PURE__ */ i(_, { ...t }) }), _ = ({
  HeroImage: t,
  isInteractive: a,
  children: u,
  testId: h = R,
  width: n = "322px",
  interactiveContent: p = { hideLabels: !1 },
  onClick: r,
  "aria-label": s
}) => {
  const [b, y] = L(!1), { isAnyOfChildrenFocused: C, headlineId: v, descriptionId: g, contentId: x } = B(), A = I(e.card, {
    [e.interactive]: a,
    [e.hideLabels]: p.hideLabels && a,
    [e.fakeHoverFocusState]: C && a,
    [e.clickable]: r
  }), o = E(null);
  N(() => {
    var c, m, f;
    const d = (c = o.current) == null ? void 0 : c.querySelectorAll("button").length, S = (m = o.current) == null ? void 0 : m.querySelectorAll("a").length;
    n && ((f = o.current) == null || f.style.setProperty("--card-width", n)), (d || S) && y(!0);
  }, [n]);
  const D = v || void 0, H = [g, x].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ F(
    O,
    {
      as: "div",
      "data-testid": h,
      ref: o,
      className: A,
      tabIndex: 0,
      role: r ? "button" : "region",
      onClick: r,
      onKeyDown: (d) => {
        P(d, r);
      },
      highlightOnHover: !b,
      "aria-label": s,
      "aria-labelledby": s ? void 0 : D,
      "aria-describedby": s ? void 0 : H,
      children: [
        /* @__PURE__ */ i("div", { className: e.heroImage, children: t }),
        u
      ]
    }
  );
};
l.Header = T;
l.Content = q;
l.Footer = K;
export {
  R as CARD_DEFAULT_TESTID,
  l as Card
};
//# sourceMappingURL=index.es26.js.map
